import { render, staticRenderFns } from "./PassengerStatusIcon.vue?vue&type=template&id=636a88e5&"
import script from "./PassengerStatusIcon.vue?vue&type=script&lang=js&"
export * from "./PassengerStatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports